import { Box, Container, Group, Tabs } from "@mantine/core"
import { ReactNode, useMemo, useState } from "react"

import { AgecStatsContainer } from "~/pages/Admin/Exports/AgecStats/AgecStatsContainer"
import { BouncedEmailsContainer } from "~/pages/Admin/Exports/BouncedEmails/BouncedEmailsContainer"

type TabsElement = {
  label: string
  component: ReactNode
}

export function Exports() {
  const tabsLabelAndComponent = useMemo<TabsElement[]>(
    () => [
      {
        label: "Bounced Emails",
        component: <BouncedEmailsContainer />,
      },
      {
        label: "Agec stats",
        component: <AgecStatsContainer />,
      },
    ],
    []
  )

  const [activeTab, setActiveTab] = useState<string | null>(
    tabsLabelAndComponent[0].label
  )

  const tabs = useMemo<TabsElement[]>(
    () =>
      tabsLabelAndComponent.map((tab) => {
        return {
          label: tab.label,
          component: activeTab === tab.label ? tab.component : null,
        }
      }),
    [activeTab, tabsLabelAndComponent]
  )

  return (
    <Container fluid p={0}>
      <Box>
        <Group gap="xl" miw={100}>
          <Tabs value={activeTab} onChange={setActiveTab} w="100%">
            <Tabs.List>
              {tabs.map((tab) => (
                <Tabs.Tab key={tab.label} value={tab.label}>
                  {tab.label}
                </Tabs.Tab>
              ))}
            </Tabs.List>
            <Container fluid py="md">
              {tabs.map((tab) => (
                <Tabs.Panel key={tab.label} value={tab.label}>
                  {tab.component}
                </Tabs.Panel>
              ))}
            </Container>
          </Tabs>
        </Group>
      </Box>
    </Container>
  )
}
